import { Controller } from "@hotwired/stimulus"

// Opens a parking gate from the dashboard. The request can take a few seconds
// (the server waits for Intratone), so the button stays disabled and the
// status line is updated for the whole round trip.
export default class extends Controller {
  static targets = ["status"]

  async open(event) {
    const button = event.currentTarget
    const { url, gate } = event.params
    const status = this.statusTargetFor(button)

    button.disabled = true
    this.setStatus(status, "Ouverture en cours…", "")

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: JSON.stringify({ gate })
      })
      const body = await response.json().catch(() => ({}))

      if (response.ok) {
        this.setStatus(status, body.message || "Porte ouverte", "text-green")
      } else {
        this.setStatus(status, body.message || "L'ouverture n'a pas pu aboutir.", "text-orange")
      }
    } catch (error) {
      this.setStatus(status, "Connexion impossible. Vérifiez votre réseau et réessayez.", "text-orange")
    } finally {
      button.disabled = false
    }
  }

  // The status line of the parking the clicked button belongs to
  statusTargetFor(button) {
    return this.statusTargets.find(target => target.closest(".gate-openings__parking") === button.closest(".gate-openings__parking"))
  }

  setStatus(status, message, className) {
    if (!status) return

    status.textContent = message
    status.className = `gate-openings__status ${className}`
  }

  get csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
